var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1.5C8.5 0.673 7.827 0 7 0H2C1.173 0 0.5 0.673 0.5 1.5V10.25C0.5 11.215 1.285 12 2.25 12H8.5C9.327 12 10 11.327 10 10.5V9H8.5V1.5ZM9 10V10.5C9 10.776 8.776 11 8.5 11H3.831C3.9395 10.7725 4 10.518 4 10.25V10H9ZM3 9V10.25C3 10.6635 2.6635 11 2.25 11C1.8365 11 1.5 10.6635 1.5 10.25V1.5C1.5 1.224 1.724 1 2 1H7C7.276 1 7.5 1.224 7.5 1.5V9H3ZM11 0C10.173 0 9.5 0.673 9.5 1.5V7.707L11 9.207L12.5 7.707V1.5C12.5 0.673 11.827 0 11 0ZM11.5 7.293L11 7.793L10.5 7.293V1.5C10.5 1.224 10.724 1 11 1C11.276 1 11.5 1.224 11.5 1.5V7.293ZM4.801 2.1465L5.508 2.8535L4.0945 4.267C3.9395 4.422 3.736 4.4995 3.5325 4.4995C3.329 4.4995 3.1255 4.422 2.9705 4.267L2.147 3.4435L2.854 2.7365L3.5325 3.415L4.801 2.1465ZM4.801 5.1465L5.508 5.8535L4.0945 7.267C3.9395 7.422 3.736 7.4995 3.5325 7.4995C3.329 7.4995 3.1255 7.422 2.9705 7.267L2.147 6.4435L2.854 5.7365L3.5325 6.415L4.801 5.1465Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.f97247bde760038aad8c27e8916f8a77.svg";
export { ForwardRef as ReactComponent };